import React from "react";
import WagerTypes from "../constants/WagerTypes";
import EntriesTable from "./EntriesTable";

const Omni = ({ raceInfo, entriesInfo, idOmni, addToCart, disabledAll }) => {
  return (
    <>
      <div
        className="tab-pane fade show active"
        id="Omni"
        role="tabpanel"
        aria-labelledby="Omni"
      >
        <EntriesTable
          raceInfo={raceInfo}
          entriesInfo={entriesInfo}
          wt={WagerTypes.OMNI.name}
          idWT={idOmni}
          addToCart={addToCart}
          disabledAll={disabledAll}
        />
      </div>
    </>
  );
};

export default Omni;
